import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import cx from 'classnames';
import { t } from '../../../../../modules/infra/i18n';

export const TABS = ['Tax Details', 'Shops & Rates', 'Products', 'Services'];

const getTranslatedTabs = () => [
  t('settings:taxes.tab_details'),
  t('settings:taxes.tab_shops_rates'),
  t('settings:taxes.tab_products'),
  t('settings:taxes.tab_services'),
];

const Header = ({ page, setPage, edit }) => (
  <ul className="layout layout--auto u-margin-auto u-text-center u-pb">
    {getTranslatedTabs().map((title, index) => (
      <li className="layout__item" key={title}>
        <Link
          className={cx('c-nav-tab', {
            'is-active': page === index,
            'u-cursor-pointer': page !== index,
            'is-disabled': !edit && index !== 0,
          })}
          onClick={edit ? () => setPage(index) : noop}
        >
          {title}
        </Link>
      </li>
    ))}
  </ul>
);

Header.propTypes = {
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  edit: PropTypes.bool,
};

Header.defaultProps = {
  edit: false,
};

export default Header;
